import { useFetchOwnPublicProfile } from "@core/features/publicProfile";
import { usePublicProfileSheet, usePlatformStore } from "@platform/store";
import { PublicProfileSheet } from "./PublicProfileSheet";

export type Props = {
  /** Program ID to scope the profile to */
  programId: number | undefined;
};

/**
 * Container component for PublicProfileSheet.
 * Handles data fetching and Zustand state for the public profile preview.
 *
 * @example
 * ```tsx
 * // In ProfilePage.tsx
 * <PublicProfileSheetContainer programId={programId} />
 * ```
 */
export function PublicProfileSheetContainer({ programId }: Props) {
  const user = usePlatformStore((s) => s.user);
  const { isOpen, close } = usePublicProfileSheet();

  const {
    data: profile,
    isLoading,
    error,
  } = useFetchOwnPublicProfile({
    programId,
    user,
    isEnabled: isOpen,
  });

  return (
    <PublicProfileSheet
      isOpen={isOpen}
      onClose={close}
      profile={profile ?? null}
      isLoading={isLoading}
      error={error?.message}
    />
  );
}

export default PublicProfileSheetContainer;
